// extracted by mini-css-extract-plugin
export default {"counterContainer":"Counter_counterContainer__H+z4W"};